import * as React from 'react';
import {Platform} from 'react-native';
import {useSelector} from 'react-redux';
import {Screens} from './model';
import {LoginScreen} from '../../screens/login';
import {createStackNavigator} from '@react-navigation/stack';
import {WebScreen} from '../../screens/webView';
import {VisuallyImpairedSettingsLoginScreen} from '../../screens/visuallyImpairedSettingsLogin';
import {useIsDesktop} from '../hooks/useIsDesktop';
import {profileSessionExpiredSelector, profileTokenSelector} from '../../redux/selectors/profile';
import {Confirmation} from '../../screens/login/confirmation';
import {GoToApp} from '../components/gotoApp';
import {EsiaRegCardFormMobile} from '../../screens/login/esiaRegCard/components/form/mobile';
import {EsiaRegCardMap} from '../../screens/login/esiaRegCard/components/map';
import esiaActivateCard from '../../screens/login/esiaActivateCard/index.native';
import {UserCardListMobile} from '../../screens/login/esiaRegCard/components/form/components/userCardList/mobile/view';
import {EsiaRegCardFormScreen} from '../../screens/login/esiaRegCard/components/form';
import {SmsEmailSubscriptionControlScreen} from '../../screens/smsEmailSubscriptionControl';

const Stack = createStackNavigator();

const emptyHeader = () => <GoToApp />;

export const LoginScreens = () => {
  const isDesktop = useIsDesktop();
  const token = useSelector(profileTokenSelector());
  const isSessionExpired = useSelector(profileSessionExpiredSelector());

  const isLoginByPasswordRequired = !token || isSessionExpired;
  const isLoginByPinCodeRequired = Platform.OS !== 'web';

  if (!isLoginByPasswordRequired && !isLoginByPinCodeRequired) {
    return null;
  }

  return (
    <Stack.Navigator
      initialRouteName={Screens.Login}
      screenOptions={{
        header: emptyHeader,
      }}>
      <Stack.Screen
        name={Screens.Login}
        component={LoginScreen}
        options={{
          title: 'Вход в систему',
        }}
      />
      <Stack.Screen
        name={Screens.LoginConfirmation}
        component={Confirmation}
        options={{title: 'Восстановление пароля'}}
      />
      <Stack.Screen
        name={Screens.SmsEmailSubscriptionControlScreen}
        component={SmsEmailSubscriptionControlScreen}
        options={{
          title: 'Управление подпиской на рассылку',
        }}
      />
      {isDesktop ? null : (
        <Stack.Screen
          name={Screens.VisuallyImpairedSettings}
          component={VisuallyImpairedSettingsLoginScreen}
          options={{header: emptyHeader, headerTransparent: false}}
        />
      )}
      <Stack.Screen
        name={Screens.WebView}
        component={WebScreen}
        options={{
          title: 'Соглашение о персональных данных',
        }}
      />
      {isDesktop ? null : (
        <Stack.Screen
          name={Screens.EsiaRegistrationCard}
          component={EsiaRegCardFormMobile}
          options={{header: emptyHeader, headerTransparent: false}}
        />
      )}
      {isDesktop ? null : (
        <Stack.Screen
          name={Screens.EsiaRegistrationCardUserSelecting}
          component={UserCardListMobile}
          options={{header: emptyHeader, headerTransparent: false}}
        />
      )}
      {isDesktop ? null : (
        <Stack.Screen
          name={Screens.EsiaRegistrationCardFormScreen}
          component={EsiaRegCardFormScreen}
          options={{header: emptyHeader, headerTransparent: false}}
        />
      )}
      {isDesktop ? null : (
        <Stack.Screen
          name={Screens.EsiaRegistrationCardMap}
          component={EsiaRegCardMap}
          options={{header: emptyHeader, headerTransparent: false}}
        />
      )}
      {isDesktop ? null : (
        <Stack.Screen
          name={Screens.EsiaActivateCard}
          component={esiaActivateCard}
          options={{header: emptyHeader, headerTransparent: false}}
        />
      )}
    </Stack.Navigator>
  );
};
